import { LicenceTypeSummary } from "../../../../types/Licences/LicenceTypeSummary";
import styled from "styled-components";
import { Form, Table } from "react-bootstrap";

interface ComparisonTableProps {
  licenceTypeSummary: LicenceTypeSummary;
}

const Container = styled.span`
  display: flex;
  justify-content: left;
  align-items: left;
  width: 100%;
  height: 100%;
`;

const AngledText = styled.span`
  transform: rotate(-30deg);
  font-weight: normal;
  font-size: 12px;
`;

const capitiliseFirstLetter = (input: string) => {
  if (!input) return "";
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
};

const ComparisonTable = ({ licenceTypeSummary }: ComparisonTableProps) => {
  return (
    <>
      <Table hover className="w-100 m-0">
        <thead>
          <tr className="border-bottom">
            <th></th>
            {licenceTypeSummary?.licenceTypes.map((licenceType, index) => {
              return (
                <th
                  className="p-2 text-left"
                  key={index}
                  style={{ width: "80px" }}
                >
                  <Container>
                    <AngledText>
                      {capitiliseFirstLetter(licenceType.name)}
                    </AngledText>
                  </Container>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {licenceTypeSummary?.layers.map((layer, index) => {
            return (
              <tr key={index}>
                <td>{layer.name}</td>
                {licenceTypeSummary.licenceTypes.map((licenceType, index) => {
                  return (
                    <td className="p-2  text-left" key={index}>
                      <Form.Check
                        disabled
                        checked={licenceType.accessibleLayers.some(
                          (x) => x.id === layer.id
                        )}
                        type="checkbox"
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
          <tr>
            <td>TomTom Access</td>
            {licenceTypeSummary?.licenceTypes.map((licenceType, index) => {
              return (
                <td className="p-2 text-left" key={index}>
                  <Form.Check
                    disabled
                    checked={licenceType.hasTomTomAccess}
                    type="checkbox"
                  />
                </td>
              );
            })}
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default ComparisonTable;
